<div class="mb-3" [innerHTML]="authService.instant('common-login-error-existing-account')"></div>
<div routerLink="/" class="btn btn-primary w-100 mt-5">{{"home-login" | translate}}</div>
